<template>
    <div>
        <b-row>
            <b-col>
                <form method="POST">
                    <table id="tabla">
                        <tr>
                            <td colspan="2"
                                class="text-center"
                            >
                                <b-form-select v-if="editarNfpa"
                                               class="select"
                                               v-model="selectedNfpa.rojo"
                                               :options="optrojo"
                                               style="width:60px;"
                                               :disabled="desactivar_edicion"
                                />
                                <h1 v-else
                                    class="mb-0"
                                >
                                    {{ selectedNfpa.rojo }}
                                </h1>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-center w-50">
                                <b-form-select v-if="editarNfpa"
                                               class="select"
                                               v-model="selectedNfpa.azul"
                                               :options="optazul"
                                               style="width:60px;"
                                               :disabled="desactivar_edicion"
                                />
                                <h1 v-else
                                    class="mb-0"
                                >
                                    {{ selectedNfpa.azul }}
                                </h1>
                            </td>
                            <td class="text-center w-50">
                                <b-form-select v-if="editarNfpa"
                                               class="select"
                                               v-model="selectedNfpa.amarillo"
                                               :options="optamarillo"
                                               style="width:60px;"
                                               :disabled="desactivar_edicion"
                                />
                                <h1 v-else
                                    class="mb-0"
                                >
                                    {{ selectedNfpa.amarillo }}
                                </h1>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"
                                class="text-center"
                            >
                                <b-form-select v-if="editarNfpa"
                                               class="select"
                                               v-model="selectedNfpa.blanco"
                                               :options="optblanco"
                                               style="width:60px;"
                                               :disabled="desactivar_edicion"
                                />
                                <h1 v-else-if="selectedNfpa.blanco"
                                    class="mb-0"
                                >
                                    {{ selectedNfpa.blanco }}
                                </h1>

                                <h1 v-else
                                    class="mb-0 heightTableNfpa"
                                >

                                </h1>
                            </td>
                        </tr>
                    </table>
                </form>
            </b-col>
        </b-row>
        <b-row v-if="opcionGuardar">
            <b-col class="text-center">
                <hr>
                <b-button v-if="editarNfpa && !desactivar_edicion"
                          size="sm"
                          variant="primary"
                          @click="guardaNfpa"
                >
                    <i class="fa fa-floppy-o"/> Guardar
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';

export default {
    name: 'Nfpa',
    props: ['editarNfpa', 'desactivar_edicion'],
    computed: {
        ...mapState('hmis', ['opciones']),
        ...mapState('nfpa', [
            'selectedNfpa',
            'defaultNfpa',
            'optrojo',
            'optazul',
            'optamarillo',
            'optblanco'
        ]),
        ...mapState('productos', [
            'opcionGuardar',
            'producto_nuevo'
        ])
    },
    async mounted() {
        this.setDefaultNfpa();
        await this.getOpciones();
        this.cargarColores(this.opciones);
        await this.getOptBlanco();
        await this.getNfpa(this.editarNfpa);
    },
    methods: {
        ...mapMutations('nfpa', ['cargarColores','setDefaultNfpa']),
        ...mapActions('hmis', [
            'getOpciones'
        ]),
        ...mapActions('nfpa', [
            'getOptRojo',
            'getOptAzul',
            'getOptAmarillo',
            'getOptBlanco',
            'guardaNfpa',
            'getNfpa',
        ])
    }
};
</script>

<style scoped>

.heightTableNfpa {
    height: 42px;
}


#tabla {
    margin: 0 auto;
    width: 90%;
    padding-top: 60px;
    height: 450px;
    width: 450px;
    background: url('/img/NFPA_704.svg') no-repeat;
    background-size: 450px 450px;
    position: relative;
}

@media only screen and (max-width: 600px) {
    #tabla {
        margin: 0 auto;
        width: 80%;
        padding-top: 50px;
        height: 200px;
        width: 200px;
        background: url('/img/NFPA_704.svg') no-repeat;
        background-size: 200px 200px;
    }

    .select {
        width: 20px !important;
    }



}
</style>
